export const live = {
  title: "ライブ",
  // VIPプロフィール画面「プレゼントCHANCE」バッジの説明文（LiveVipPresentBadge）
  onedariGameDescription:
    "配信中にギフトを送ってプレゼントを解禁しよう！\n配信中に使われたポイントに応じて、プレゼントが段階的にオープン！\n使ったポイントが多いほど応募口数が増えて、当選チャンスアップ！",
  listTitle: "配信",
  trending: "急上昇",
  // ライブ一覧の急上昇セクション見出し用（カード上の「急上昇」バッジは trending のまま）
  liveNowSectionTitle: "配信中のユーザー",
  free: "無料",
  freeWatching: "無料視聴中",
  live: "LIVE",
  // BottomNav の無料視聴対象配信バッジ用
  limitedLive: "限定LIVE",
  limitedLiveAppear: (args: { name: string | number }) => `${args.name}登場！`,
  // BottomNav のお気に入りユーザー配信中バッジ用（タブラベルは「配信」のまま変えない）
  favoriteBroadcastLive: "お気に入りの女性が配信中",
  // ライブ一覧カードのお気に入り強調バッジ用
  favoriteBadge: "お気に入り",
  // ライブ一覧の Lovenseバッジ（評価バッジ「遠隔バイブ反応◎」獲得済み）セクション見出し用
  lovenseBadgeSectionTitle: "遠隔バイブ高感度ユーザー",
  // Sakura版一覧カードのサムネイル上に表示する訴求タグ（Lovenseバッジ獲得済み配信者向け）
  lovenseReactionLabel: "遠隔バイブ反応大",
  standby: "待機中",
  viewerCount: (args: { count: string | number }) => `${args.count}人視聴中`,
  pastBroadcastNotice: "※再生されている映像は過去の配信映像です。",
  pointPerMinute: (args: { point: string | number }) => `${args.point}pt/分`,
  noChannels: "ライブ配信中のチャンネルはありません",
  leave: "終了",
  remainingPoint: (args: { point: string | number }) => `残り ${args.point}pt`,
  chatPlaceholder: "メッセージ",
  // 無料配信のコメント入力欄プレースホルダー（文字数上限の案内）
  chatPlaceholderMaxLength: (args: { max: string | number }) =>
    `${args.max}文字以内で入力してください`,
  // 無料配信のコメントフィルタ（送信ブロック時のトースト）
  commentFilter: {
    tooLong: (args: { max: string | number }) =>
      `${args.max}文字以内で入力してください`,
    bannedWord: "この内容は送信できません",
  },
  // 配信入室時に自動送信する挨拶メッセージ（本家 Utage 同様）
  autoGreeting: "こんにちは",
  // 配信入室時に自動送信する入室通知メッセージ（本家 Utage の message_type: "entering" 相当）
  joinNotification: (args: { name: string | number }) =>
    `${args.name}さんが入室しました！`,
  toyMenu: "Toyメニュー",
  toyPointCost: (args: { point: string | number }) => `${args.point}pt`,
  durationSeconds: (args: { duration: string | number }) =>
    `${args.duration}秒`,
  purchase: "購入",
  remoteVibe: "遠隔バイブ",
  remoteVibeMenuTitle: "遠隔バイブメニュー",
  onedari: "おねだり",
  onedariTitle: "おねだりメニュー",
  // 深田えいみコラボ限定メニュー（fukada_present_menu_items）の category → 表示ラベル。
  // BE の category は固定列挙ではないため、未マップのキーはコンポーネント側でキー文字列をそのまま表示する
  onedariCategoryLabels: {
    reaction: "リアクション",
    message: "メッセージ",
    action: "アクション",
    gift: "ギフト",
  } as Record<string, string>,
  // 深田えいみコラボ（無料視聴）画面専用の「おねだり」の言い換え表記
  gift: "ギフト",
  giftMenuTitle: "ギフトメニュー",
  // 簡易ギフトメニュー（LiveOnedariQuickMenu）下部の連打誘導
  comboHint: "連打でコンボ!",
  // ギフト送信ポップアップ（LiveOnedariGiftPopup）。アバターには先頭1文字を使う。
  // 他視聴者の高額送信（300pt以上）は送信者名を表示し、otherName は名前が取れない場合の総称
  giftPopup: {
    selfName: "あなた",
    otherName: "視聴者",
  },
  // 無料視聴画面・通常配信を開いた直後に出す操作誘導（ボタンの強調）
  entryCoachmark: {
    // ギフト(🎁)ボタンは簡易メニューより高額なギフトを送れるため文言で区別する
    giftTapLabel: "高額ギフトは\nここをタップ！",
    // 通常配信の初回入室コーチマーク（おねだり→Lovense の順に表示）
    onedariTapLabel: "おねだりは\nここをタップ！",
    lovenseTapLabel: "遠隔バイブは\nここをタップ！",
    broadcasterInvite: (args: { name: string | number }) =>
      `${args.name}に\nギフトを贈ろう♡`,
    // 通常配信のクイックラブンスメニュー用の吹き出し文言
    lovenseInvite: (args: { name: string | number }) =>
      `${args.name}を\n遠隔バイブで\nイカせよう♡`,
    bubbleCta: "ここをタップ！",
  },
  // 最新メッセージへ移動ボタン（cap到達後の自動追従停止時のみ表示）の a11y ラベル
  jumpToLatest: "最新のメッセージへ移動",
  lovenseSentMessage: (args: { name: string | number }) =>
    `「${args.name}」の遠隔バイブを送信しました💗`,
  // 初回視聴者向け無料Lovense機能のボタン発火用ラベル（押下回数ごとに段階的に文言を変える。
  // シーケンスは強度の欠品スキップで3回未満になり得るため最終押下は total 基準で判定する。
  // 送信時のチャット告知は通常の lovenseSentMessage と同じ文言を使う）
  freeLovenseButtonLabel: (args: {
    press: number | string;
    total: number | string;
  }) => {
    const press = Number(args.press);
    if (press >= Number(args.total)) return "イカせるチャンス！";
    if (press >= 2) return "もっと気持ちよくさせよう";
    return "タップして気持ちよくさせよう";
  },
  // ボタン下に出す吹き出し文言（残り発火可能回数を添える）
  freeLovenseCallout: (args: { count: string | number }) =>
    `無料遠隔バイブチャンス あと${args.count}回`,
  // 丸ボタン内に表示する短いタップ誘導文言
  freeLovenseTapLabel: "タップ",
  // ライブ一覧カードで無料Lovense対象（待機中+Lovense対応）の配信者に表示するタグ
  freeLovenseTag: "無料で遠隔バイブ体験",
  presentSentMessage: (args: {
    text: string | number;
    point: string | number;
  }) => `「${args.text}」（${args.point}pt）のチップを送信しました！🎁`,
  presentSendError: "ギフトを送信できませんでした",
  // 簡易おねだりメニュー（LiveOnedariQuickMenu）連打時の節目コンボ演出
  onedariCombo: (args: { count: string | number }) => `×${args.count} COMBO!`,
  chargeTitle: "ポイントをチャージ",
  chargeDoneTitle: "チャージ完了！",
  chargeDoneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
  insufficientPointTitle: "ポイントが不足しています",
  insufficientPointDescription:
    "ライブを視聴するにはポイントが必要です。ポイントを購入してください。",
  pointWarning: (args: { minutes: string | number }) =>
    `残り${args.minutes}分でポイントが不足します`,
  lovenseOfflineError:
    "相手の遠隔バイブがオフライン状態のため送信できませんでした。",
  lovenseSendError:
    "遠隔バイブの送信に失敗しました。時間をおいて再度お試しください。",
  lovenseActive: "実行中",
  lovenseControlling: "コントロール中",
  lovenseRemaining: (args: { seconds: string | number }) =>
    `残り${args.seconds}秒`,
  lovenseIntensity: (args: { intensity: string | number }) =>
    `強度 ${args.intensity}/20`,
  lovenseFullControlMenu: "完全コントロールメニュー",
  lovenseHide: "非表示",
  lovenseTypes: {
    // BE displayName（完全コントロール）に合わせる。メニュー由来 type("full_control") で
    // 引いたときと、ログ由来 type("完全コントロール") のフォールバック表示を一致させる。
    full_control: "完全コントロール",
  },
  insufficientPointToast: "ポイント不足により視聴が終了しました",
  pointWillRunOutToast: "残り1分で視聴が終了します",
  openProfile: "配信者のプロフィールを表示",
  mute: "ミュート",
  unmute: "ミュート解除",
  leaveConfirm: {
    title: "視聴を終了しますか？",
    confirm: "終了する",
  },
  entryCountdown: {
    badge: "まもなく入室します",
    description: "自動で配信に入室します",
    cancel: "キャンセル",
  },
  // おねだり連打の達成度に応じてコラボグッズが解禁されるイベントゲージ（無料視聴画面）の文言
  prizeGauge: {
    title: "消費合計ポイント",
    myContribution: "貢献ポイント",
    // カード左上に出す機能名タイトル
    gameTitle: "ギフトチャレンジ！",
    // ゲージバー起点（0pt位置）のラベル
    barStart: "Start",
    hide: "非表示",
    reopen: "進捗を表示",
    // 達成済み節目の報酬画像に被せるバッジ
    milestoneAchievedBadge: "達成",
    // 消費ptカード左に出す「次に解禁される賞品」の見出しラベル
    nextPresentLabel: "NEXT PRESENT",
    helpAriaLabel: "消費ptの説明",
    // 節目・目標達成セレブレーション（フルスクリーン演出）の文言
    celebrationMilestoneLabel: "MILESTONE",
    celebrationCongratulationsLabel: "CONGRATULATIONS",
    celebrationAchievedTitle: (args: { point: string | number }) =>
      `${args.point}pt 達成!`,
    celebrationFinalAchievedTitle: (args: { point: string | number }) =>
      `${args.point}pt 達成!!`,
    celebrationPrizeUnlocked: "プレゼント解放!",
    celebrationRewardGetLabel: "REWARD GET",
    celebrationNextMilestone: (args: {
      point: string | number;
      rewardName: string;
    }) => `次は ${args.point}pt で「${args.rewardName}」`,
    celebrationFinalThanks: "たくさんのギフトありがとう 💖",
    celebrationCloseAriaLabel: "演出を閉じる",
    // ステージクリア（次ステージ解禁）演出。中間節目より大きく、最終節目(ギフト開封)より軽いジャックポット演出
    celebrationStageUnlockedTitle: "解禁!!",
    celebrationStageNextHint: (args: { point: string | number }) =>
      `次のステージは ${args.point}pt から`,
    // ゲージ上部のステージバッジ（0段目=最初のステージでは表示しない）。序数語(SECOND/THIRD...)を差し込む
    stageBadgeOrdinal: (args: { ordinal: string }) => `${args.ordinal} STAGE`,
    stageBadgeFinal: "FINAL STAGE",
  },
  // 消費ptゲージの「？」から開くおねだりゲーム説明モーダル（デザイン: おねだりゲーム説明ポップ 1c）の文言
  onedariHelp: {
    title: "ギフトチャレンジとは？",
    intro:
      "みんなでギフトを贈ってゲージを貯めよう！消費ptに応じてプレゼントが解放されます。",
    presentsHeading: "解放されるプレゼント",
    presentsNote:
      "※プレゼント画像はイメージです。実際は配信で本人が着用したものをそのままプレゼントします。",
    howToHeading: "ギフトゲージの貯めかた",
    // 貯めかた説明画像（送り方2箇所の注釈入りスクリーンショット）の代替テキスト
    // TODO: 画像アセット(/campaign/onedari-help-how-to.webp)自体が旧文言のスクリーンショットのため差し替えが必要
    howToImageAlt:
      "ギフトの送り方: 画面右の「ギフト」ボタンか、画面右下の🎁アイコンをタップ",
  },
  // 無料配信者がいるときだけ一覧最上部に出す「深田えいみコラボ」ヒーロー枠の文言
  freeWatchingFeatured: {
    collabTitle: "深田えいみコラボ", // 上部中央タイトル
    completelyFree: "完全無料", // カード内 💛 バッジ
    tonightLimited: "今夜限定", // カード内 🌙 バッジ
    specialGuest: "スペシャルゲスト配信中",
    watchFree: "無料で見る",
    note: "今夜限定の女性配信者が来てます！今だけポイント消費なし",
  },
  // 深田えいみキャンペーン期間中だけ一覧最上部に出すカウントダウンバナーの文言
  eimiCountdown: {
    badge: "LIVE予告",
    // 配信中はカウントダウン予告ではなく実況中を示す文言に切り替える
    liveBadge: "LIVE中",
    performerName: "深田えいみ",
    // performerName は別 span で太字表示するため、こちらは接尾辞のみ
    // アプリ名（Carina/Renka/Sakura等）は applicationId によって変わるため引数で受け取る
    // EimiCountdownBanner / BoardEimiCountdownLabel で使用中のため残置
    arrivalSuffix: (args: { appName: string | number }) =>
      `が${args.appName}にやってくる！`,
    // EimiCountdownTicker: 演者名・アプリ名を別 span で個別に強調表示するため分割して持つ
    arrivalParticle: "が",
    arrivalTail: "にやってくる！",
    // 簡易ラベル用: 「深田えいみの配信まであと8日と08:07:01」の「の配信まで」部分
    untilBroadcastSuffix: "の配信まで",
    liveNowCta: "配信中！今すぐ視聴 ▶",
    // 掲示板の全幅バー用: 本文とCTAチップを分けて表示するため liveNowCta とは別に持つ
    liveNowSuffix: "無料限定Live配信中！",
    watchCta: "今すぐ無料視聴 ▶",
    remainingPrefix: "あと",
    daySuffix: "日",
    dayConnector: "と",
  },
  // 限定配信者(無料視聴)向け VIP プロフィール画面（デザイン: VIPプロフィール案 1a イマーシブ・ストーリー）
  // 「LIVE」「待機中」は TEXT.live.live / TEXT.live.standby を流用する（重複追加しない）
  vipProfile: {
    marquee: (args: { name: string | number }) =>
      `✦ 今夜限り ${args.name}登場 20時からLive配信にて生着替え`,
    presentBadgeWear: (args: { name: string | number }) =>
      `${args.name}着用水着`,
    presentBadgeGift: "プレゼント",
    presentBadgeChance: "CHANCE",
    presentHelpAriaLabel: "プレゼントCHANCEの説明を見る",
    presentHelpTitle: "プレゼントCHANCEとは？",
    presentHelpClose: "閉じる",
    broadcasting: "配信中",
    selfIntro: "自己紹介",
    review: "レビュー",
    seeAll: "すべて見る ›",
    noReviews: "まだレビューはありません",
    lovenseTag: "遠隔バイブ対応",
    enter: "入室する",
    free: "完全無料",
    notFound: "この配信は見つかりませんでした",
  },
} as const;
